import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubmissionFormComponent } from './components/submission-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	declarations: [SubmissionFormComponent],
	imports: [CommonModule, FormsModule, ReactiveFormsModule]
})
export class SubmissionFormModule {}
